/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Air_Handler_Unit_Actuator_Warning_5Inputs */



/**
* | output |
* | --- |
* | "Without command and without run feedback, the state is not displayed" |
*
* @param {Air_Handler_Unit_Actuator_Warning_5Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const air_handler_unit_actuator_warning_5 = /** @type {((inputs?: Air_Handler_Unit_Actuator_Warning_5Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Air_Handler_Unit_Actuator_Warning_5Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Without command and without run feedback, the state is not displayed")
	return /** @type {LocalizedString} */ ("En l'absence de commande et de retour de marche, l'état n'est pas affiché")
});